<template>
    <v-container style="display: block; padding: 0px;" fluid>

        <v-container class="top-section" fluid>
            <v-row>
                <v-text-field class="search-text" v-model="searchText" placeholder="Search Reports..." single-line append-icon="search" color="#c42111" hide-details></v-text-field>

                <v-divider class="ml-5" vertical :style="{height: '25px', marginTop: '22px', borderColor: '#EAECEE'}" />

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template #activator="{ on: onTooltip }">
                        <v-btn class="ml-5 mt-3" color="#303030" fab small @click="toggleFilterFavs" title="Filter Favorites" v-on="{ ...onTooltip }">
                            <v-icon class="filter" :color="$props.reportFilters.report_filter_favs ? 'yellow' : '#ffffff'">mdi-star</v-icon>
                        </v-btn>
                    </template>
                    <span>Filter Favorites</span>
                </v-tooltip>

                <v-divider class="ml-5" vertical :style="{height: '25px', marginTop: '22px', borderColor: '#EAECEE'}" />

                <v-btn class="ml-5 mt-3" color="#303030" fab @click="setDisplayMethod('list')" small title="List View">
                    <v-icon :color="$props.reportFilters.report_display_method == 'list' ? '#c42111' : '#ffffff'">mdi-view-headline</v-icon>
                </v-btn>
                <v-btn class="ml-3 mt-3" color="#303030" fab @click="setDisplayMethod('tile')" small title="Tile View">
                    <v-icon :color="$props.reportFilters.report_display_method == 'tile' ? '#c42111' : '#ffffff'">mdi-view-module</v-icon>
                </v-btn>

                <v-divider class="ml-5" vertical :style="{height: '25px', marginTop: '22px', borderColor: '#EAECEE'}" />

                <v-btn class="ml-5 mt-3" color="#303030" fab @click="expandAllPanels" small title="Expand All Panels">
                    <v-icon>mdi-expand-all</v-icon>
                </v-btn>
                <v-btn class="ml-3 mt-3" color="#303030" fab @click="collapseAllPanels" small title="Collapse All Panels">
                    <v-icon>mdi-collapse-all</v-icon>
                </v-btn>
            </v-row>
        </v-container>

        <div>
            <v-expansion-panels v-model="expandedPanels" multiple>

                <v-expansion-panel v-for="reportGroup in reportGroups" :key="reportGroup.group" style="background-color: #303030;">
                    <v-expansion-panel-header style="fontWeight: bold;">{{ reportGroup.group }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <div class="mt-2" v-if="$props.reportFilters.report_display_method == 'tile'">
                            <v-card class="report-container" :class="{unallowed: !report.report.hasPermissions}" v-for="report in reportGroup.reports" :key="report.report.user_obj_name" @click="$emit('reportClicked', report.report)">
                                <span class="report-title" v-text="report.report.user_obj_name.split('/')[0] + '/'" style="fontWeight: bold;" />
                                <span class="report-title" v-text="report.report.user_obj_name.split('/')[1]" />
                                <span class="report-info" v-text="report.report.user_obj_description" />
                                <v-icon class="fav" :class="{selected: report.report.fav}" @click.stop="toggleFav(report.report)" v-if="!report.report.test">mdi-star</v-icon>
                                <v-icon class="delete" @click.stop="deleteTestReportClick(report.report)" v-if="report.report.test">mdi-delete-forever</v-icon>
                            </v-card>
                        </div>

                        <div class="mt-2" v-if="$props.reportFilters.report_display_method == 'list'">
                            <v-row dense no-gutters>
                                <v-col cols="12" lg="12" v-for="report in reportGroup.reports" :key="report.report.user_obj_name">
                                    <div class="list-report-container mb-2" :class="{unallowed: !report.report.hasPermissions}" @click="$emit('reportClicked', report.report)">
                                        <v-row dense no-gutters>
                                            <v-col cols="4">
                                                <span class="report-title" v-text="report.report.user_obj_name.split('/')[0] + '/'" style="fontWeight: bold;" />
                                                <span class="report-title" v-text="report.report.user_obj_name.split('/')[1]" />
                                            </v-col>
                                            <v-col cols="6">
                                                <span class="report-info ml-4" v-text="report.report.user_obj_description" />
                                                <v-icon class="ml-1 docs" @click.stop="showReportDocumentation(report.report)" title="Report Documentation" v-if="report.report.docs">mdi-information-outline</v-icon>
                                            </v-col>
                                            <v-col cols="1">
                                                <v-icon class="fav" :class="{selected: report.report.fav}" @click.stop="toggleFav(report.report)" title="Toggle Favorite" v-if="!report.report.test">mdi-star</v-icon>                                                
                                            </v-col>
                                            <v-col cols="1">
                                                <v-icon class="delete" @click.stop="deleteTestReportClick(report.report)" v-if="report.report.test">mdi-delete-forever</v-icon>
                                                <v-icon class="delete" @click.stop="$emit('deleteLicensableReportClick', report.report)" v-if="isTsAdmin && !report.report.test">mdi-delete-forever</v-icon>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                    </v-expansion-panel-content>
                </v-expansion-panel>

            </v-expansion-panels>
        </div>


        <v-expansion-panels v-model="licensableReportsPanel" class="mt-4" v-if="isTsAdmin">
            <v-expansion-panel style="background-color: #c42111;">
                <v-expansion-panel-header style="fontWeight: bold;">
                    <span class="justify-start"><v-icon color="#fcba03" class="mr-2" style="font-size: 20px;">mdi-key-variant</v-icon> Loadable Reports</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                    <v-row dense no-gutters>
                        <v-col cols="12" lg="12" v-for="report in licensableReports" :key="report.lr_name">

                            <div class="list-report-container mb-2" @click="$emit('licensableReportClick', report)">
                                <v-row dense no-gutters>
                                    <v-col cols="9">
                                        <span class="report-title" v-text="report.lr_name.split('/')[0] + '/'" style="fontWeight: bold;" />
                                        <span class="report-title" v-text="report.lr_name.split('/')[1]" />
                                    </v-col>
                                    <v-col cols="3">
                                        <v-chip label outlined color="green" style="height: 22px; margin-top: -5px;" v-if="report.lr_available">Returns Results</v-chip>
                                        <v-chip label outlined color="gray" style="height: 22px; margin-top: -5px;" v-else>Empty Results</v-chip>
                                    </v-col>
                                </v-row>
                            </div>

                        </v-col>
                    </v-row>
                    
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>




        <docs-dialog v-model="showReportDocsModal" :title="selectedReportDocs.user_obj_name" :docs="selectedReportDocs.docs" v-if="showReportDocsModal" />

    </v-container>
</template>

<script>
import DocsDialog from '@/components/Reports/DocsDialog';
export default {
    name: 'ReportsList',
    props: ['reports', 'reportFilters', 'licensableReports'],
    components: {
        DocsDialog
    },
    data: () => ({
        searchText: '',
        expandedPanels: [],
        colors: [
            {category: 'CDMA', color: '#FF5722'},
            {category: 'CDRs', color: '#FF9700'},
            {category: 'Datafill', color: '#2296F3'},
            {category: 'EEGS', color: '#4BAF50'},
            {category: 'E-UTRAN', color: '#8BC34A'},
            {category: 'LTE RAN', color: '#F44336'},
            {category: 'MTX Logs', color: '#01BCD4'},
            {category: 'PDSN', color: '#8BC34A'},
            {category: 'Switch CORE', color: '#FFEB3B'},
            {category: 'TecAlert', color: '#E91E62'},
            {category: 'Transport', color: '#01BCD4'},
            {category: '[TEST]', color: '#FF0000'},
            {category: '', color: ''},
        ],
        selectedReportDocs: null,
        showReportDocsModal: false,
        licensableReportsPanel: []
    }),

    computed: {
        filteredReportList: function() {
            return this.reports.filter(r => {
                return ( 
                    (
                        !this.searchText || 
                            ((r.user_obj_description.toLowerCase().includes(this.searchText.toLowerCase())) ||
                            (r.docs && r.docs.toLowerCase().includes(this.searchText.toLowerCase())) ||
                            (r.user_obj_name.toLowerCase().includes(this.searchText.toLowerCase())) ||
                            (typeof r.user_obj_data == 'string' && r.user_obj_data.toLowerCase().includes(this.searchText.toLowerCase())))
                    )
                    &&
                    (
                        !this.$props.reportFilters.report_filter_favs || r.fav
                    )
                );
            }).sort(function(a, b){
                if(a.user_obj_name < b.user_obj_name) { return -1; }
                if(a.user_obj_name > b.user_obj_name) { return 1; }
                return 0;
            });
        },

        reportGroups: function() {
            let results = [];
            let groupName;
            let addGroup = true;
            for(let report of this.filteredReportList) {
                groupName = report.user_obj_name.split('/')[0];
                addGroup = true;
                for(let result of results) {
                    if(result.group == groupName) {
                        result.reports.push({
                            group: groupName,
                            report: report
                        });
                        addGroup = false;
                    }
                }
                if(addGroup) {
                    results.push({
                        group: groupName,
                        reports: [
                            {
                                group: groupName,
                                report: report
                            }
                        ]
                    });
                }
            }
            return results;
        },

        isTsAdmin: function() {
            if(this.$store.state.user.user_data && this.$store.state.user.user_data.is_telsasoft_admin) {
                return true;
            }
            return false;
        }
    },

    methods: {
        getColor: function(name) {
            let cat = name.split('/')[0];
            for(let color of this.colors) {
                if(cat.toLowerCase() == color.category.toLowerCase()) {
                    return color.color;
                }
            }
            return '#ffffff';
        },

        toggleFav: function(report) {
            report.fav = !report.fav;
            this.$emit('filters');
        },

        toggleFilterFavs: function() {
            this.$props.reportFilters.report_filter_favs = !this.$props.reportFilters.report_filter_favs;
            this.$emit('filters');
        },

        setDisplayMethod: function(method) {
            this.$props.reportFilters.report_display_method = method;
            this.$emit('filters');
        },

        expandAllPanels: function() {
            this.expandedPanels = [...Array(this.reportGroups.length).keys()];
        },
        collapseAllPanels: function() {
            this.expandedPanels = [];
        },

        deleteTestReportClick: function(report) {
            this.$store.commit('showConfirmModal', {
                type: 'delete',
                hideCancel: false,
                title: 'Are you sure?',
                message: `Are you sure you want to delete <b>${report.user_obj_name}</b>`,
                confirmAction: () => {this.deleteTestReport(report);}
            });
        },
        deleteTestReport: function(report) {
            let route = (TELSA.apiHost + "report/delete");
            this.$http.post(route, {args: {report: report}}).then(response => {
                let result = response.body;
                console.log(result);
                this.$emit('reload');
            });
        },

        showReportDocumentation: function(report) {
            this.selectedReportDocs = report;
            this.showReportDocsModal = true;
        }
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .search-text {
        margin-bottom: 1em;
        max-width: 30em;
    }

    @media (max-width: 910px) {
        .search-text {
            max-width: 340px;
        }
    }

    .report-container {
        width: calc((100% - 4em) / 4);
        height: 6em;
        border: #fff solid 1px;
        display: inline-block;
        cursor: pointer;
        margin-right: 1em;
        margin-bottom: 1em;
        padding-top: 0.5em;
        padding-left: 0.5em;
        position: relative;
        float: left;
        background-color: #424242;
        
    }
    @media (max-width: 1450px) {
        .report-container {
            width: calc((100% - 3em) / 3);
        }
    }
    @media (max-width: 900px) {
        .report-container {
            width: calc((100% - 2em) / 2);
        }
    }
    @media (max-width: 650px) {
        .report-container {
            width: 100%;
        }
    }
    .report-container:hover {
        box-shadow: 4px 4px 5px -2px rgba(0, 0, 0, 0.6);
    }

    .report-container .report-title {
        position: relative;
        display: inline-block;
        font-size: 12pt;
        color: #ffffff;
    }

    .report-container .report-info {
        position: relative;
        display: block;
        font-size: 9pt;
        color: #ffffff;
        width: 75%;
    }

    .report-container .fav {
        color: #fff;
        position: absolute;
        right: 0.5em;
        font-size: 32pt;
        top: calc(50% - (42px / 2));
    }

    .report-container .fav.selected {
        color: yellow;;
    }

    .report-container .delete {
        color: #fff;
        position: absolute;
        right: 0.5em;
        font-size: 32pt;
        top: calc(50% - (42px / 2));
    }
    .report-container .delete:hover {
        color: red;
    }
    
    .top-section {
        padding-top: 0;
        padding-right: 0;
    }
    .filter.selected {
        color: yellow;;
    }

    .list-report-container {
        background-color: #424242;
        color: #ffffff;
        height: 40px;
        padding: 8px;
        cursor: pointer;
        border: solid 1px #212121;
        border-radius: 2px;
    }
    .list-report-container:hover {
        box-shadow: 4px 4px 5px -2px rgba(0, 0, 0, 0.6);
    }

    .list-report-container .report-info {
        font-size: 11pt;
    }

    .list-report-container .fav {
    }
    .list-report-container .fav.selected {
        color: yellow;
    }

    .list-report-container .delete:hover {
        color: red;
    }

    .unallowed {
        opacity: 0.6;
    }

</style>

